import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';

import GmailField from './GmailField';
import { Col, Row, Select, SelectOption, Input } from 'components/ui';
import { EMAIL_SERVICES, SEND_THROUGH_LIST } from 'constants/common';

const SenderField = ({ sendThroughList = SEND_THROUGH_LIST }) => {
  const { control, trigger, watch } = useFormContext();

  const isMultiMode = watch('isMultiMode');
  const isMicrosoft = watch('isMicrosoft');
  const forceChoose = watch('force_choose');
  const templateHasForceChoose = !!watch('selectedTemplateForceChoose');

  const espList = isMicrosoft
    ? sendThroughList.filter(e => ['SendGrid', 'SparkPost'].includes(e))
    : sendThroughList;

  const isGmailSender = [
    EMAIL_SERVICES.GMAIL,
    EMAIL_SERVICES.MICROSOFT,
  ].includes(forceChoose);

  return (
    <section className="send-mail-form__section">
      <h5>Sender *</h5>
      <Row gutter={8}>
        <Col span={7}>
          {isGmailSender && (
            <Input
              disabled
              id="sender-name"
              label="Sender's name"
              name="senderName"
              type="text"
            />
          )}

          {!isGmailSender && (
            <Controller
              control={control}
              name="senderName"
              render={({ field, fieldState }) => {
                return (
                  <Input
                    {...commonProps({
                      field,
                      fieldState,
                      isMultiMode,
                      placeholder: 'Turing',
                    })}
                    id="sender-name"
                    label="Sender's name"
                    name="senderName"
                    type="text"
                  />
                );
              }}
            />
          )}
        </Col>

        {isGmailSender && (
          <Col span={7}>
            <Controller
              control={control}
              name="authorizedAccountId"
              render={({ field, fieldState }) => {
                return (
                  <GmailField
                    {...commonProps({
                      field,
                      fieldState,
                      isMultiMode,
                      placeholder: 'Select Gmail Account',
                    })}
                    name="authorizedAccountId"
                  />
                );
              }}
            />
          </Col>
        )}

        {!isGmailSender && (
          <Col span={7}>
            <Controller
              control={control}
              name="senderEmail"
              render={({ field, fieldState }) => {
                return (
                  <Input
                    {...commonProps({
                      field,
                      fieldState,
                      isMultiMode,
                      placeholder: 'no-reply@turing.com',
                    })}
                    id="sender-email"
                    label="Sender's Email"
                    name="senderEmail"
                    type="email"
                  />
                );
              }}
            />
          </Col>
        )}

        <Col span={8}>
          <label className="input-name">Send Through</label>
          <Controller
            control={control}
            name="force_choose"
            render={({ field: { value, onChange, onBlur } }) => {
              return (
                <Select
                  className="force-choose-select"
                  disabled={isMultiMode || templateHasForceChoose}
                  name="selectedSendThrough"
                  style={{ width: '100%' }}
                  value={value}
                  onBlur={onBlur}
                  onChange={sendThrough => {
                    onChange(sendThrough);
                    trigger(['senderName', 'senderEmail']);
                  }}
                >
                  <SelectOption key="default" value="-1">
                    Automated Load Balancing
                  </SelectOption>
                  {espList.map(sendThrough => (
                    <SelectOption key={sendThrough} value={sendThrough}>
                      {sendThrough}
                    </SelectOption>
                  ))}
                </Select>
              );
            }}
          />
        </Col>
      </Row>
    </section>
  );
};

const commonProps = ({
  isMultiMode,
  fieldState,
  field,
  disabled,
  placeholder,
}) => {
  if (isMultiMode)
    return {
      disabled: true,
      error: false,
      helperTxt: '',
      placeholder: '',
    };

  return {
    disabled,
    placeholder,
    error: !!fieldState.error,
    value: field.value,
    helperTxt: fieldState.error?.message,
    onBlur: field.onBlur,
    onChange: field.onChange,
  };
};

export default SenderField;
